import { Loader2 } from "lucide-react";
import React from "react";

interface LoaderProps {
  isLoading: boolean;
  message?: string;
}

export const Loader: React.FC<LoaderProps> = ({ isLoading, message }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-green-700" />
        {message && <p className="text-gray-700">{message}</p>}
      </div>
    </div>
  );
}; 